import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=d695b3ac&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=d695b3ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d695b3ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d695b3ac')) {
      api.createRecord('d695b3ac', component.options)
    } else {
      api.reload('d695b3ac', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=d695b3ac&scoped=true&", function () {
      api.rerender('d695b3ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2geDea4EA5jrk/JS/comp/DocBox.vue"
export default component.exports